// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"be36ba4f2bbaaed0","4044":"2cf69365c373181e","4515":"be36ba4f2bbaaed0","4969":"ec3868b085b66aca","5264":"36c696450100bc60","8378":"44f02bd565bcad18"}[chunkId] + ".css";
};